import { render, staticRenderFns } from "./M-Img.vue?vue&type=template&id=f0b29c16&lang=pug&"
import script from "./M-Img.vue?vue&type=script&lang=js&"
export * from "./M-Img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports